<template>
    <div>
        <validation-provider v-slot="{ errors }" :rules='{ required: required, isPhone: nameRef == "phoneNumber"}' :name="label">
            <v-text-field
                    ref="refEl"
                    type="number"
                    v-model="myValue"
                    :class="[classExtra ]"
                    :maxlength="maxlength"
                    :minlength="minlength"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    :outlined="outlined"
                    :label="label"
                    :clearable="clearable"
                    :readonly="readonly"
                    :error-messages="errors"
                    :validate-on-blur="true"
                    @input="myValue= myValue.replace(/[^0-9\.]/g,'');"
                    @change="$emit('searchInput', {
										    data: myValue,
                        name: nameRef,
                        event: eventModel,
                        change: true,
                  })"
                    @keydown.enter="$emit('searchInput', {
										    data: myValue,
                        name: nameRef,
                        event: eventModel,
                        change: true,
                  })"
            >
                <template  v-slot:label>
                    {{ label }}<span v-if="required " style="color: red;margin-left: 2px;">*</span>
                </template>
            </v-text-field>
        </validation-provider>
    </div>
</template>
<script>
import { COMMON_PROPS_INPUT } from "@/pages/teacher-support/constaint/input";

export default {
    name: "BaseNumber",
    props: { ...COMMON_PROPS_INPUT },
    data(){
        return {
            myValue: '',
        }
    },
    created() {
        this.myValue = this.value
    },
    watch: {
        myValue() {
            this.$emit('input', this.myValue)
        },
        value(valueData) {
            if (!valueData || valueData.toString().trim().length === 0) {
                this.myValue = ''
            } else {
                this.myValue = valueData.trimStart()
            }
        },

    },
}
</script>